// reviewWriteConfig 섹션별 세부 가이드 (각 아코디언 박스의 ? 클릭 시 실행)
// 페이지 가이드(key: 'reviewWriteConfig')와 별개. 박스를 펼친 뒤 그 안의 핵심 항목을 안내한다.
// 레지스트리 키 규칙: 'reviewWriteConfig:<섹션key>'  (섹션key = openRwcSection 값)
import { buildSteps } from '../tourStep';

// specs 배열 → (ctx, tour) 빌더. 각 항목은 data-tour 셀렉터에 부착.
const make = (specs) => (ctx, tour) => buildSteps(
  specs.map(s => ({
    ...s,
    attachTo: { element: s.sel, on: s.on || 'top' },
    beforeShow: s.sel,
  })),
  tour
);

// === 기본 리뷰위젯(상세페이지) ===
export const buildRwcDetailWidgetSteps = make([
  { id: 'count', emoji: '🔢', title: '리뷰 리스트 표시 갯수', text: '상품 상세 페이지에 한 번에 보여줄 <b>리뷰 개수</b>예요.', sel: '[data-tour="rwc-dw-count"]' },
  { id: 'sort', emoji: '↕️', title: '리스트 정렬', text: '리뷰 <b>정렬 방식</b>(최신순·추천순 등)을 정해요.', sel: '[data-tour="rwc-dw-sort"]' },
  { id: 'version', emoji: '🖥️', title: '리뷰상세 보기 버전', text: '리뷰를 클릭했을 때 열리는 <b>상세 뷰어 버전</b>을 선택해요.', sel: '[data-tour="rwc-dw-version"]' },
]);

// === 카페24 설정 ===
export const buildRwcCafe24Steps = make([
  { id: 'board', emoji: '🔢', title: '리뷰 게시판 ID', text: '카페24 <b>리뷰 게시판 번호</b>예요. 보통 <b>4번</b>이며, 카페24 &gt; 게시판 &gt; 게시판관리에서 확인해요. 이 값이 맞아야 리뷰가 정상 연동돼요.', sel: '[data-tour="rwc-cafe24-board"]' },
  { id: 'url', emoji: '🔗', title: '상품 상세 URL 형식', text: '쇼핑몰 상품 상세 페이지 <b>URL 형식</b>(쉬운/기본)을 골라요. 위젯이 상품 페이지로 올바르게 이동하도록 쇼핑몰 설정에 맞춰주세요.', sel: '[data-tour="rwc-cafe24-url"]' },
]);

// === 작성 설정 ===
export const buildRwcWriteSteps = make([
  { id: 'period', emoji: '🗓️', title: '작성 가능 시점 및 기간', text: '구매 후 <b>언제부터·며칠 동안</b> 리뷰를 작성할 수 있는지 설정해요.', sel: '[data-tour="rwc-write-period"]' },
  { id: 'chars', emoji: '🔤', title: '글자수 제한', text: '리뷰 본문의 <b>최소·최대 글자수</b>를 정해요.', sel: '[data-tour="rwc-write-chars"]' },
  { id: 'pending', emoji: '⏳', title: '리뷰 별점에 따른 대기 처리', text: '특정 별점 이하의 리뷰를 자동으로 <b>관리자 승인 대기</b>로 보낼 수 있어요.', sel: '[data-tour="rwc-write-pending"]' },
]);

// === 디자인 ===
export const buildRwcDesignSteps = make([
  { id: 'font', emoji: '🅰️', title: '기본 폰트 색상', text: '위젯의 <b>기본 글자 색상</b>이에요.', sel: '[data-tour="rwc-design-font"]' },
  { id: 'theme', emoji: '🎨', title: '테마 폰트 색상', text: '강조에 쓰이는 <b>테마 색상</b>이에요.', sel: '[data-tour="rwc-design-theme"]' },
  { id: 'star', emoji: '⭐', title: '별점 색상', text: '별점 아이콘 <b>색상</b>이에요.', sel: '[data-tour="rwc-design-star"]' },
]);

// === 리뷰 댓글(답글) 설정 ===
export const buildRwcCommentSteps = make([
  { id: 'writer', emoji: '🙋', title: '댓글 작성자 이름', text: '리뷰 답글에 표시될 <b>작성자(관리자) 이름</b>이에요.', sel: '[data-tour="rwc-comment-writer"]' },
  { id: 'pw', emoji: '🔒', title: '댓글 관리자 비밀번호', text: '카페24에 답글을 <b>등록·수정</b>할 때 필요한 비밀번호예요.', sel: '[data-tour="rwc-comment-pw"]' },
  { id: 'config', emoji: '💬', title: '리뷰 댓글 설정', text: '답글 노출·작성 관련 <b>옵션</b>이에요.', sel: '[data-tour="rwc-comment-config"]' },
]);

// === 리뷰정보 노출 설정 ===
export const buildRwcDisplaySteps = make([
  { id: 'date', emoji: '📅', title: '날짜 · 작성자 노출', text: '리뷰 <b>작성 날짜</b>와 <b>작성자 정보</b>를 각각 노출할지 정해요.', sel: '[data-tour="rwc-display-date"]' },
  { id: 'name', emoji: '🆔', title: '작성자명 표시 방식', text: '작성자 <b>이름/ID</b> 표시 방식과 <b>노출 글자 수(마스킹)</b>를 정해요.', sel: '[data-tour="rwc-display-name"]' },
]);

// === 별점·리뷰수 위젯 ===
export const buildRwcReviewRatingCountSteps = make([
  { id: 'main', emoji: '⭐', title: '별점 및 리뷰수', text: '상품에 <b>별점과 리뷰 수</b>를 함께 보여주는 위젯이에요.', sel: '[data-tour="rwc-rrc-main"]' },
  { id: 'margin', emoji: '📐', title: '여백 (상단/하단/좌우)', text: '위젯의 <b>상단·하단·좌우 여백</b>을 조정해요.', sel: '[data-tour="rwc-rrc-margin"]' },
]);

// === 제품(리스트) 리뷰 정보 ===
export const buildRwcProductListSteps = make([
  { id: 'show', emoji: '⭐', title: '리뷰 수/별점 노출', text: '상품 <b>리스트(목록)</b>에 별점·리뷰 수를 노출할지 정해요.', sel: '[data-tour="rwc-pl-show"]' },
  { id: 'pos', emoji: '📍', title: '정렬 위치', text: '리스트 항목 안에서 위젯이 <b>표시될 위치</b>예요.', sel: '[data-tour="rwc-pl-pos"]' },
  { id: 'class', emoji: '🏷️', title: '제품리스트 클래스', text: '상품 리스트의 <b>부모 요소(클래스/ID)</b>를 지정해 위젯을 삽입해요.', sel: '[data-tour="rwc-pl-class"]' },
]);

// === CSS ===
export const buildRwcCssSteps = make([
  { id: 'url', emoji: '🎛️', title: 'CSS 파일 URL', text: '위젯에 적용할 <b>커스텀 CSS 파일 URL</b>이에요. 세밀한 디자인이 필요한 고급 사용자용.', sel: '[data-tour="rwc-css-url"]' },
]);
